// Thin wrapper over Umami's client API.
//
// Most CTAs are tracked declaratively with `data-umami-event="..."` attributes,
// which Umami's script picks up on click and which need no code. Use this helper
// only for events that aren't a click — chiefly a form submit that we want to
// count on SUCCESS, not on the button press.
//
// Deliberately silent and defensive: umami is a deferred third-party-blockable
// script (and absent entirely in dev), so `window.umami` may never appear.
// Analytics must never break the page.
export function track(event, data) {
  try {
    window.umami?.track?.(event, data)
  } catch {
    // never let analytics throw into the UI
  }
}
